import placeholder from '~/assets/icons/placeholder.svg';
import { documentAvailable } from '~/utils/client-detection';

const styleCss = `

.label-image{
	max-width: 1200px;
	width: auto;
	height: auto;
}

.highlights {
	border: 1px solid hotpink;
}

.more-info-text > * > ul {
	list-style: square !important;
	margin-left: 10px !important;
}
.header--loaded {
	z-index: 10;
}
div[data-fefa-custom-id="priceDetailsLayer"] * {
	color: #333333;
}
// div[data-fefa-layer-active="true"] {
// 	z-index: 2000;
// 	position: fixed;
// }
button[data-testid="private-leasing-cta"] {
	color: white !important;
	font-size: 10px;
	margin-top: 3px;
}
button[data-testid="private-leasing-cta"]:hover {
	color: #b3b3b3 !important;
}

body .nm-wrapper{
	max-width: 100%;
}
body .nm-footer{
	z-index: 10;
}
.MuiBackdrop-root {
	background-color: rgba(0, 0, 0, 0.9) !important;

}
.MuiPaper-rounded {
	border-radius: 0px !important;
}
.MuiPaper-root {
	margin: 0px !important;
	width: 100vw;
	max-width: 1024px !important;
	padding-top: 3rem;
	padding-bottom: 3rem;
	padding-left: 2.5rem;
	padding-right: 2.5rem;
	max-height: 100% !important;
	gap: 4rem;
}

.bg-grey-5 {
	background-color: #f2f2f2;
}

.h-full	{
	min-height: 100%;
}

.cancel-button {
	cursor: pointer;
	width: 48px;
	height: 48px;
	.cancel-large {
		width: 48px;
		height: 48px;
		font-size: 48px;
	}
}

.dialog-close {
	position: absolute;
	top: 0px;
	right: 0px;
}


.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)) {
	margin-bottom: 1.25em;
}

.more-info-slider {
	overflow: visible;
	.slider-action-expand-catalogue {
		display: none;
	}
	.slider-stage__canvas-item {
		filter: none;
	}
}

.gallery-summary-images-dialog {
	.dialog-close {
		z-index: 100;
		color: white;
	}
}
.gallery-icon-summary {
	position: absolute;
    right: 5px;
    bottom: 5px;
    color: white;
    // background: #f2f2f2;
    padding: 5px;
    width: 35px;
    height: 35px;
	cursor: pointer;
}
.image-text-text {
	text-transform: capitalize;
	text-align: center;
}
.gallery-carline-image {
	transition: all 200ms ease-in-out;
	background-size: cover;
    background-repeat: no-repeat;
	background-position: center;
	height: 80px;
	width: 140px;
	min-width: 140px;
	cursor: pointer;
	&:hover {
		// height: 100px;
		width: 160px;
	}
	&.active-image {
		border: 4px solid white;
	}
	p {
		position: absolute;
		left: 50%
		bottom: -15px;
		width: 140px;
		transform: translateX(-50%);
	}
}
.image-not-available {
	position: relative;
	overflow: hidden;
	&:before {
		content: ' ';
		display: block;
		position: absolute;
		left: 0;
		top: 0%;
		width: 100%;
		height: 100%;
		opacity: 0.3;
		background-image: url(${placeholder});
		background-repeat: no-repeat;
		background-position: 50% 50%;
		background-size: cover;
	}
}
@media (max-width: 679px) {
	.accessory-content__item {
		.simple-card__main {
			.selection-card-container {
				display: flex;
				flex-direction: row;
				.selection-card__image {
					width: 70px !important;
					height: 50px !important;
					margin: 10px 0px 10px 10px
				}
				.selection-card__control {
					flex: 1;
					margin: 10px auto;
				}
				.selection-card__content {
					margin: auto 0 auto auto;
					.price-month-rate{
						white-space: nowrap;
					}
				}
			}
		}
	}
}
@media (max-width: 400px) {
	.accessory-content__item {
		.simple-card__main {
			.selection-card-container {
				flex-wrap: wrap;
				.selection-card__control {
					flex-basis: 100%;
					order: 1;
				}
			}
		}
	}
}


@media (max-width: 756px) {
	.go-first-action, .go-last-action {
		display: none;
	}
}
@media (max-width: 1024px) {
	.gallery-summary-images-dialog {
		.gallery-carline-image {
			height: 40px;
			width: 70px;
			min-width: 70px;
			&:hover {
				// height: 60px;
				width: 80px;
				min-width: 80px;
			}
		}
		.image-text-text {
			display: none;
		}
	}
}

.summary-no-bar {
	&.image-toggle {
		right: 65px;
		@media (max-width: 1023px) {
			right: 55px;
		}
	}
	.icon__container {
		font-size: 35px;
		padding: 8px;
		backdrop-filter: blur(8px);
		background: rgba(0,0,0,0.3);
		right: 25px;
		bottom: 25px;
		width: 50px;
		height: 50px;
		transition: all 300ms ease-in-out;
		@media (max-width: 1023px) {
			width: 40px;
			height: 40px;
			font-size: 24px;
			right: 15px;
			bottom: 15px;
		}
		&:after {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}

	}
	&.active {
		.icon__container {
            background: white;
            color: black;
		}
	}
}


`;

const style = documentAvailable() ? document.createElement('style') : undefined;
style && style.appendChild(document.createTextNode(styleCss));

export { style };
